module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [(_vm.notEditingDocket) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-3"
  }, [(_vm.docket.number) ? _c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Docket Number")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.decoratedDocket.number) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-3"
  }, [(_vm.docket.number) ? _c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Net Weight")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.decoratedDocket.weight) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-3 col-lg-2"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v(" "), _c('span', {
    class: _vm.decoratedDocket.status_class
  }, [_vm._v(_vm._s(_vm.decoratedDocket.status_text))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-3 col-lg-4"
  }, [_c('p', {
    staticClass: "material-details truncate"
  }, [_c('strong', [_vm._v("File")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.urlToDownloadDocket
    }
  }, [_vm._v(_vm._s(_vm.decoratedDocket.photo_name))])])])]) : _vm._e(), _vm._v(" "), (_vm.docketIsResubmit && _vm.notEditingDocket) ? _c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Resubmit File")]), _c('br'), _vm._v("\n    " + _vm._s(_vm.docket.rejection_reason) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.editingDocket) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-3"
  }, [_c('p', {
    staticClass: "material-details truncate"
  }, [_c('strong', [_vm._v("Docket Number")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "number"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-3"
  }, [_c('p', {
    staticClass: "material-details truncate"
  }, [_c('strong', [_vm._v("Net Weight")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.weight),
      expression: "weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "number"
    },
    domProps: {
      "value": (_vm.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weight = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.file
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('label', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "for": ("docket-" + (_vm.identifiers.id))
    }
  }, [_c('input', {
    staticClass: "sr-only",
    attrs: {
      "type": "file",
      "name": "file",
      "id": ("docket-" + (_vm.identifiers.id)),
      "accept": ".jpg,.jpeg,.png,.gif"
    },
    on: {
      "change": _vm.handleFileSelection
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-upload"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.canSeeDocketButtons) ? _c('ul', {
    staticClass: "load-actions"
  }, [_c('li', [_c('a', {
    staticClass: "btn btn-circle btn-info",
    class: {
      'disabled': _vm.docketIsBeingPreviewed
    },
    on: {
      "click": _vm.handlePreviewDocket
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])]), _vm._v(" "), (_vm.canModifyDocket) ? _c('li', [_c('a', {
    staticClass: "btn btn-circle btn-info",
    on: {
      "click": _vm.handleToggleEditDocket
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])]) : _vm._e(), _vm._v(" "), (_vm.canDeleteDocket) ? _c('li', [_c('ladda-button', {
    staticClass: "btn btn-circle btn-danger",
    attrs: {
      "on-click": _vm.handleDeleteDocket
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-alt"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.canRejectDocket) ? _c('li', [(_vm.docketIsPending) ? _c('ladda-button', {
    staticClass: "btn btn-circle alert-reason",
    attrs: {
      "on-click": _vm.handleRejectDocket,
      "type": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.canApproveDocket) ? _c('li', [(_vm.docketIsPending) ? _c('ladda-button', {
    staticClass: "btn btn-circle btn-success",
    attrs: {
      "on-click": _vm.handleApproveDocket
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.canSaveDocket) ? _c('div', {
    staticClass: "load-actions m-t-sm"
  }, [_c('a', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": _vm.handleToggleEditDocket
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('ladda-button', {
    attrs: {
      "on-click": _vm.handleSaveDocket,
      "size": "small",
      "type": "success"
    }
  }, [_vm._v("Save")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "material-details truncate",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('strong', {
    staticClass: "select-label"
  }, [_vm._v("Docket Image")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-5a2ab9fc"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/LoadCheckModalItem.vue
// module id = 1011
// module chunks = 0